import { useFeatureGate } from '@ctct/awesome-feature-flags';
import { envs, urlParams } from '@ctct/infrastructure-layer';

export const useHidePromoCodesForStripeMultimonthGate = () => {
  if (envs.isSecure()) {
    const isHidePromoCodesViaUrlParam = urlParams.getIfHidePromoCodesTurnedOn();

    return {
      data: isHidePromoCodesViaUrlParam,
      isLoading: false,
      isError: false,
      error: null,
    } as ReturnType<typeof useFeatureGate>;
  }

  // hooks list will be stable per env, so we can safely disable the hooks rule
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useFeatureGate({
    name: 'hide_promo_codes_for_stripe_multimonth',
    defaultValue: false,
  });
};
